<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :batch-edit="auth('b_product_edit')" :view-config="auth('b_product_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="仓库">
							<c-select name="warehouse_id" async @search="searchWarehouse"></c-select>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="产品规格">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="工艺路线">
							<c-select name="route_ids" multiple async @search="searchRoute"></c-select>
						</m-search-item>
						<m-search-item label="产品来源">
							<c-checkbox-group :options="productSourceName" name="product_sources"></c-checkbox-group>
						</m-search-item>
						<m-search-item label="产品类型">
							<c-checkbox-group :options="productTypeName" name="product_types"></c-checkbox-group>
						</m-search-item>
						<m-search-item label="产品状态">
							<c-checkbox-group name="product_states" multiple :options="productStateDic"></c-checkbox-group>
						</m-search-item>
						<m-search-item>
							<c-checkbox-group :options="bomDicState" name="is_product_bom_states"></c-checkbox-group>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_product_edit')" v-lock="lock('b_product_edit')" prepend-icon="tf-add" @click="$refs.productEdit.open()">创建产品</c-button>
					<c-button v-if="auth('b_product_export')" v-lock="lock('b_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_product_export')" v-lock="lock('b_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_product_edit')" v-lock="lock('b_product_edit')" prepend-icon="tf-import" @click="$refs.view.excelImport()">导入</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_product_export')" v-lock="lock('b_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_product_export')" v-lock="lock('b_product_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_product_print')" v-lock="lock('b_product_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-button v-if="auth('b_product_edit')" v-lock="lock('b_product_edit')" prepend-icon="tf-trash" color="red" :hollow="true" @click="batchRemoveProduct">删除</c-button>
				</template>

				<template #otherOperate>
					<c-button v-if="auth('b_product_log')" v-lock="lock('b_product_log')" prepend-icon="tf-import-record" @click="$refs.view.loadImportLogDetail()">导入记录</c-button>
					<c-button v-if="auth('b_product_log')" v-lock="lock('b_product_log')" prepend-icon="tf-operate-record" @click="$refs.view.loadWorkLogDetail()">操作记录</c-button>
				</template>

				<template #product_source="{data}">
					<c-state dict="productSourceName" :value="data.product_source"></c-state>
				</template>
				
				<template #product_type="{data}">
					<c-state dict="productTypeName" :value="data.product_type"></c-state>
				</template>

				<!--产品状态（视图字段 product_state，有权限显示启停开关，无权限显示状态标签）-->
				<template #product_state="{data}">
					<c-switch v-if="auth('b_product_state')" v-model="data.product_state" :state-value="[1, 2]" :state-text="['启用','停用']" @beforeChange="stateHandle(arguments[0], arguments[1], data)"></c-switch>
					<c-state v-else dict="productStateDic" :value="data.product_state"></c-state>
				</template>
				<c-table-column
					type="button"
					label="操作"
					width="220"
					button-limit="4"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_product_edit')" v-lock="lock('b_product_edit')" icon="tf-edit" @click="$refs.productEdit.open(data)">编辑</c-table-button>
						<c-table-button v-if="auth('b_product_copy')" v-lock="lock('b_product_copy')" icon="tf-copy" @click="$refs.productEdit.open(data,true)">复制</c-table-button>
						<c-table-button v-if="auth('b_product_print')" v-lock="lock('b_product_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
						<c-table-button v-if="auth('b_product_material')" v-lock="lock('b_product_material')" icon="tf-detail" @click="viewProductMaterial(data)">查看物料清单</c-table-button>
						<c-table-button v-if="auth('b_material_edit')" v-lock="lock('b_material_edit')" icon="tf-edit" @click="editProductMaterial(data)">编辑物料清单</c-table-button>
						<c-table-button v-if="auth('b_product_edit')" v-lock="lock('b_product_edit')" icon="tf-trash" @click="removeProduct(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--新增/编辑产品弹窗-->
			<product-edit ref="productEdit" @resolve="$refs.view.update()"></product-edit>
			<!--新增/编辑物料弹窗-->
			<material-edit ref="materialEdit"></material-edit>
			<!--物料清单树-->
			<material-tree ref="materialTree"></material-tree>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	import productEdit from "@/pages/basic/product_edit.vue";
	import materialEdit from "@/pages/basic/product_material_edit.vue";
	import materialTree from "@/pages/basic/product_material_tree.vue";

	export default {
		components: {
			materialEdit,
			materialTree,
			productEdit
		},

		data() {
			return {
				workType:7
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState(['productSourceName', 'productTypeName', "bomDicState", 'productStateDic']),
		},

		methods: {
			/******产品启停用**********/
			stateHandle(state, next, data) {
				this.request({
					url: '/product/edit/state',
					data: {
						id: data.id,
						product_state: state ? 2 : 1
					},
					success: () => {
						next();
						this.$message({
							message: (state ? '停用' : '启用') + '成功',  // 提示内容,
							type: 'success'
						});
					}
				})
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*******搜索产品-工艺路线*****************/
			searchRoute(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'PROCESSROUTE_SEARCH',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/******查询物料清单**********/
			viewProductMaterial(data){
				this.$refs.materialTree.open(data);
			},

			/******编辑物料清单**********/
			editProductMaterial(data){
				data.parent_product_id = data.id;
				this.$refs.materialEdit.open({
					parent_product_id: data.product_id
				});
			},

			/****批量删除产品****/
			batchRemoveProduct(){
				var ids = [];
				this.$refs.view.$refs.list.getData('selected').forEach(item => {
					ids.push(item.id);
				});
				
				this.$confirm({
					message:'确认删除' + ids.length + '条产品记录吗？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product/remove/batch',
							data: {ids: ids},
							loading: true,
							success: data => {
								let Mtype = 'success';
								let message = '成功' + data.success_count + '条';
								if(data.fail_count > 0 && data.success_count > 0){
									Mtype = 'warn';
									message += '，失败'+data.fail_count+'条';
								}else if(data.fail_count > 0 && data.success_count == 0){
									Mtype = 'fail'
									message += '，失败'+data.fail_count+'条';
								}else{
									message = '成功删除' + data.success_count + '条记录';
								}
								this.$message({
									message: message,  // 提示内容,
									type: Mtype
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/******删除产品**********/
			removeProduct(data){
				this.$confirm({
					message:'确认删除产品【'+data.product_name+'】？删除后不可恢复',  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/product/remove',
							data: {id:data.id},
							loading: true,
							success: data => {
								this.$message({
									message:'删除成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>